/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Modal = ({ title, content, modalActive, showModal }) => {
  return (
    <div className={`modal${modalActive ? " is-active" : ""}`}>
      <div onClick={() => showModal(false)} className="modal-background"></div>
      <div className="modal-card">
        <section className="modal-card-body">
          <h1 className="title has-text-left">
            <i className="fas fa-check successIcon"></i> {title}
          </h1>
          <h2 className="subtitle modalContent has-text-left">{content}</h2>

          <div className="field is-grouped is-pulled-right">
            <p className="control">
              <a className="button is-link" onClick={() => showModal(false)}>
                Okay
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Modal;
